import React, { useEffect, useState } from 'react';
import './Busqueda.css';
import { useNavigate } from 'react-router-dom';
import Circulo from '../../img/Circulo.png';
import { Form } from 'react-final-form';
import Select from "react-select";
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import confetti from 'canvas-confetti';

const Busqueda4 = () => {
    const jwtToken = localStorage.getItem('accessToken');
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const companyId = user?.data?.attributes?.empresa?.id || null;
    const [competencias, setCompetencias] = useState([]);
    const [idiomas, setIdiomas] = useState([]);
    const [personalidad, setPersonalidad] = useState([]);
    const [competencia, setCompetencia] = useState(JSON.parse(localStorage.getItem("competenciasBuscadas") || '[]'));
    const [formularioPerso, setFormularioPerso] = useState(localStorage.getItem("formularioPersoBuscado") || "");
    const [idioma, setIdioma] = useState(JSON.parse(localStorage.getItem("idiomaBuscado") || '[]'));
    const [postgrado, setPostgrado] = useState(localStorage.getItem("postgradoBuscado") || null);


    useEffect(() => {
        fetch(`https://gqim2rhigi.execute-api.us-east-1.amazonaws.com/prod-wot-backend/obtenerListas/competencias`)
            .then(response => response.json())
            .then(data => {
                const competencias = data.map((index) => {
                    return { value: index.id, label: index.competencia };
                });
                setCompetencias(competencias);
            });
        fetch(`https://gqim2rhigi.execute-api.us-east-1.amazonaws.com/prod-wot-backend/obtenerListas/idiomas`)
            .then(response => response.json())
            .then(data => {
                const idiomas = data.map((index) => {
                    return { value: index.id, label: index.nombre };
                });
                setIdiomas(idiomas);
            });
        fetch(`https://gqim2rhigi.execute-api.us-east-1.amazonaws.com/prod-wot-backend/obtenerListas/formularios`)
            .then(response => response.json())
            .then(data => {
                const personalidad = data.map((index) => {
                    return { value: index.id, label: index.personalidad };
                });
                setPersonalidad(personalidad);
            });
    }, []);

    const handlePostgrado = (e) => {
        setPostgrado(e.target.value);
        localStorage.setItem("postgradoBuscado", e.target.value);
    }
    const handleCompetencia = (selectedOptions) => {
        if (selectedOptions.length <= 5) {
            setCompetencia(selectedOptions);
            localStorage.setItem("competenciasBuscadas", JSON.stringify(selectedOptions));
        } else {
            alert("Solo puedes seleccionar hasta 5 competencias.");
        }
    }
    const handleIdioma = (selectedOptions) => {
        setIdioma(selectedOptions);
        localStorage.setItem("idiomaBuscado", JSON.stringify(selectedOptions));
    }
    const handlePersonalidad = (e) => {
        setFormularioPerso(e.target.value);
        localStorage.setItem("formularioPersoBuscado", e.target.value);
    }
    const navigate = useNavigate();

    function busqueda3() {
        navigate('/form-busqueda3');
    }

    const handleSubmit = async (e) => {
        if (competencia.length === 0) {
            alert("Por favor, completa todos los campos obligatorios.");
            return;
        } else {
            navigate('/form-busqueda-extra')
        }
    }

    return (
        <div className="WT1">
                <label className='numero1-busquedas'>1</label>
                <label className='numero2-busquedas'>2</label>
                <label className='numero3-busquedas' id='active'>3</label>
                <label className='busqueda-busquedas'>Búsqueda</label>
                <label className='perfilProfesional-busquedas'>Perfil profesional</label>
                <label className='requisitos-busquedas' id='negrita-busquedas'>Requisitos</label>
                <div className='container-busquedas'>
                    <link href='https://fonts.googleapis.com/css2?family=Montserrat:wght@800&display=swap' rel='stylesheet'></link>
                    <h3 className='texto1-busquedas'>¡Estas haciendo tu formulario de búsqueda!</h3>
                    <Form
                        onSubmit={handleSubmit}
                        render={({ handleSubmit, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <div className='postgrado-busquedas'>
                                    <label>Quieres que tenga postgrado</label>
                                    <div></div>
                                    <select value={postgrado} onChange={handlePostgrado} className='input-postgrado'>
                                        <option value=""></option>
                                        <option value={true}>Si</option>
                                        <option value={false}>No / Indiferente</option>
                                    </select>
                                </div>
                                <div className='resultadoPerso'>
                                    <label> Qué características de personalidad estimas son más compatibles con el cargo y la organización? </label>
                                    <select value={formularioPerso} onChange={handlePersonalidad} className='input-personalidad'>
                                        <option value=""></option>
                                        {personalidad.map((index) => {
                                            return (
                                                <option key={index.value} value={index.value}>{index.label}</option>
                                            );
                                        })}
                                    </select>
                                </div>
                                <div className='competencias-busquedas'>
                                    <label> Competencias <span className='rojo'>*</span></label>
                                    <div></div>
                                    <label className='ejemplo-area'><span className='rojo'> Seleccionar máximo 5 respuestas </span></label>
                                    <div></div>
                                    <Select
                                        className='input-competencias'
                                        value={competencia}
                                        onChange={handleCompetencia}
                                        options={competencias}
                                        isMulti
                                        maxValue={5}
                                    />
                                </div>
                                <div className='idioma-busquedas'>
                                    <label> Dominio de idioma medio-avanzado </label>
                                    <div></div>
                                    <label className='ejemplo-area'><span className='rojo'> Selecciona todas las opciones que correspondan </span></label>
                                    <div></div>
                                    <Select
                                        className='input-idiomas'
                                        value={idioma}
                                        onChange={handleIdioma}
                                        options={idiomas}
                                        isMulti
                                    />
                                </div>
                            </form>
                        )}
                    />
                    <progress id="barra" max="100" value="100"> 100% </progress>
                    <label className='porcentaje'>100%</label>
                    <button id='siguiente-busquedas' onClick={(e) => {handleSubmit()} }>
                        Siguiente
                    </button>
                    <button id='atras-busquedas' onClick={busqueda3}> Atras </button>
                </div>
                <div className='rectangulo-busquedas'></div>
                <img src={Circulo} alt='circulo' className='wot-circulo' />
            </div>
    )
}

export default Busqueda4;